import { createFileRoute } from "@tanstack/react-router";
import { AgentChatSession } from "@/components/chat/session";

import { ChatApiFactory } from "@/apis/chat";
import { ChatSession as IChatSession } from "@/schema/chat";

export const Route = createFileRoute("/chat/p/$session")({
  loader: async ({ params }) => ChatApiFactory.Apis.FetchChatSessionPublic(params.session),
  component: RouteComponent,
  staleTime: 0,
  gcTime: 0,
});

function RouteComponent() {
  const data = Route.useLoaderData();

  return (
    <div className="bg-sidebar h-[100dvh] flex flex-col">
      <ChatSession key={data.id} data={data} />
    </div>
  );
}

interface ChatSessionProps {
  data: IChatSession;
}

function ChatSession({ data }: ChatSessionProps) {
  return <AgentChatSession key={data.id} data={data} visibility="public" />;
}
